<script>
  import { format } from 'svelte-i18n';

  import { SectionItem } from '@client/components/section';
  import { Select } from '@client/components/select';

  import { bannerStore } from '@client/stores/banner';

  let bannerTypeOptions = [
    {
      label: $format('label.IMAGE'),
      value: 'image'
    },
    {
      label: $format('label.TEXT'),
      value: 'text'
    }
  ];

  // svelte-ignore unused-export-let
  export let altText = 'banner';
  export let appendImage = false;
  export let imagePlaceholder;
  export let type = bannerTypeOptions[0];

  let banner;

  $: loaded = $bannerStore.loaded;

  $: {
    appendImage = type.value === 'image';
  }

  $: if (loaded) {
    banner = $bannerStore.bannerOptions.find(({ src }) => src === imagePlaceholder) || $bannerStore.bannerOptions[0];
    imagePlaceholder = banner?.src;
  }
</script>

<SectionItem
  label={$format('label.BANNER_TYPE')}
  tooltip={$format('label.TOOLTIP.BANNER_TYPE')}
  description={$format('label.DESCRIPTION.BANNER_TYPE')}
  class={type.value === 'text' ? 'p-0' : ''}
>
  <Select
    items={bannerTypeOptions}
    bind:value={type}
    placeholder={$format('label.PLACEHOLDER.SELECT_BANNER_TYPE')}
    clearable={false}
    showChevron
  />
</SectionItem>

{#if type.value === 'image'}
  <SectionItem
    label={$format('label.BANNER_IMAGE')}
    description={$format('label.DESCRIPTION.BANNER_IMAGE')}
    data-testid="image-section"
  >
    <Select
      items={$bannerStore.bannerOptions}
      bind:value={banner}
      placeholder={$format('label.PLACEHOLDER.SELECT_BANNER')}
      class="select-element"
      clearable={false}
      disabled={!loaded}
      showChevron
      on:change={(e) => {
        imagePlaceholder = e.detail?.src;
      }}
    >
      <svelte:fragment slot="item" let:item>
        <div class="item">
          <div class="item-detail">
            <div class="name">{item.value}</div>
            <div class="image">
              <img src={item.src} alt={item.value} loading="lazy" />
            </div>
          </div>
        </div>
      </svelte:fragment>
    </Select>
    {#if banner}
      <div class="source banner">
        <img src={banner.src} alt={banner.value} loading="lazy" />
      </div>
    {/if}
  </SectionItem>
{/if}

<style lang="scss" src="./banner.scss"></style>
